webpackJsonp([253011397747672],{

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(232);
	var v4 = __webpack_require__(233);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ }),

/***/ 112:
/***/ (function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  return bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}
	
	module.exports = bytesToUuid;


/***/ }),

/***/ 113:
/***/ (function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && msCrypto.getRandomValues.bind(msCrypto));
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(113);
	var bytesToUuid = __webpack_require__(112);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(113);
	var bytesToUuid = __webpack_require__(112);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeatureGrid = function FeatureGrid(_ref) {
	  var gridItems = _ref.gridItems;
	  return _react2.default.createElement(
	    'div',
	    { className: 'columns is-multiline' },
	    gridItems.map(function (item) {
	      return _react2.default.createElement(
	        'div',
	        { key: item.image, className: 'column is-6' },
	        _react2.default.createElement(
	          'section',
	          { className: 'section' },
	          _react2.default.createElement(
	            'p',
	            { className: 'has-text-centered' },
	            _react2.default.createElement('img', { alt: '', src: item.image })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            item.text
	          )
	        )
	      );
	    })
	  );
	};
	
	FeatureGrid.propTypes = {
	  gridItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    image: _propTypes2.default.string,
	    text: _propTypes2.default.string
	  }))
	};
	
	exports.default = FeatureGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pricing = function Pricing(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'columns' },
	    data.map(function (price) {
	      return _react2.default.createElement(
	        'div',
	        { key: price.plan, className: 'column' },
	        _react2.default.createElement(
	          'section',
	          { className: 'section' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'has-text-centered has-text-weight-semibold' },
	            price.plan
	          ),
	          _react2.default.createElement(
	            'h2',
	            { className: 'is-size-1 has-text-weight-bold has-text-primary has-text-centered' },
	            '$',
	            price.price
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'has-text-weight-semibold' },
	            price.description
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            price.items.map(function (item) {
	              return _react2.default.createElement(
	                'li',
	                { key: item, className: 'is-size-5' },
	                item
	              );
	            })
	          )
	        )
	      );
	    })
	  );
	};
	
	Pricing.propTypes = {
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    plan: _propTypes2.default.string,
	    price: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    description: _propTypes2.default.string,
	    items: _propTypes2.default.array
	  }))
	};
	
	exports.default = Pricing;
	module.exports = exports['default'];

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uuid = __webpack_require__(231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Testimonials = function Testimonials(_ref) {
	  var testimonials = _ref.testimonials;
	  return _react2.default.createElement(
	    'div',
	    null,
	    testimonials.map(function (testimonial) {
	      return _react2.default.createElement(
	        'article',
	        { key: (0, _uuid.v4)(), className: 'message' },
	        _react2.default.createElement(
	          'div',
	          { className: 'message-body' },
	          testimonial.quote,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'cite',
	            null,
	            ' \u2013 ',
	            testimonial.author
	          )
	        )
	      );
	    })
	  );
	};
	
	Testimonials.propTypes = {
	  testimonials: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    quote: _propTypes2.default.string,
	    author: _propTypes2.default.string
	  }))
	};
	
	exports.default = Testimonials;
	module.exports = exports['default'];

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.productPageQuery = exports.ProductPageTemplate = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Features = __webpack_require__(122);
	
	var _Features2 = _interopRequireDefault(_Features);
	
	var _Testimonials = __webpack_require__(124);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	var _Pricing = __webpack_require__(123);
	
	var _Pricing2 = _interopRequireDefault(_Pricing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductPageTemplate = exports.ProductPageTemplate = function ProductPageTemplate(_ref) {
	  var image = _ref.image,
	      title = _ref.title,
	      heading = _ref.heading,
	      description = _ref.description,
	      intro = _ref.intro,
	      main = _ref.main,
	      testimonials = _ref.testimonials,
	      fullImage = _ref.fullImage,
	      pricing = _ref.pricing;
	  return _react2.default.createElement(
	    'section',
	    { className: 'section section--gradient' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-10 is-offset-1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'content' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'full-width-image-container margin-top-0',
	                  style: { backgroundImage: 'url(' + image + ')' }
	                },
	                _react2.default.createElement(
	                  'h2',
	                  {
	                    className: 'has-text-weight-bold is-size-1',
	                    style: {
	                      boxShadow: '0.5rem 0 0 #f40, -0.5rem 0 0 #f40',
	                      backgroundColor: '#f40',
	                      color: 'white',
	                      padding: '1rem'
	                    }
	                  },
	                  title
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'columns' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'column is-7' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'has-text-weight-semibold is-size-2' },
	                    heading
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    description
	                  )
	                )
	              ),
	              _react2.default.createElement(_Features2.default, { gridItems: intro.blurbs }),
	              _react2.default.createElement(
	                'div',
	                { className: 'columns' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'column is-7' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'has-text-weight-semibold is-size-3' },
	                    main.heading
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    main.description
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'tile is-ancestor' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tile is-vertical' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tile' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tile is-parent is-vertical' },
	                      _react2.default.createElement(
	                        'article',
	                        { className: 'tile is-child' },
	                        _react2.default.createElement('img', {
	                          style: { borderRadius: '5px' },
	                          src: main.image1.image,
	                          alt: main.image1.alt
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tile is-parent' },
	                      _react2.default.createElement(
	                        'article',
	                        { className: 'tile is-child' },
	                        _react2.default.createElement('img', {
	                          style: { borderRadius: '5px' },
	                          src: main.image2.image,
	                          alt: main.image2.alt
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tile is-parent' },
	                    _react2.default.createElement(
	                      'article',
	                      { className: 'tile is-child' },
	                      _react2.default.createElement('img', {
	                        style: { borderRadius: '5px' },
	                        src: main.image3.image,
	                        alt: main.image3.alt
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(_Testimonials2.default, { testimonials: testimonials }),
	              _react2.default.createElement('div', {
	                className: 'full-width-image-container',
	                style: { backgroundImage: 'url(' + fullImage + ')' }
	              }),
	              _react2.default.createElement(
	                'h2',
	                { className: 'has-text-weight-semibold is-size-2' },
	                pricing.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'is-size-5' },
	                pricing.description
	              ),
	              _react2.default.createElement(_Pricing2.default, { data: pricing.plans })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	ProductPageTemplate.propTypes = {
	  image: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  heading: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  intro: _propTypes2.default.shape({
	    blurbs: _propTypes2.default.array
	  }),
	  main: _propTypes2.default.shape({
	    heading: _propTypes2.default.string,
	    description: _propTypes2.default.string,
	    image1: _propTypes2.default.object,
	    image2: _propTypes2.default.object,
	    image3: _propTypes2.default.object
	  }),
	  testimonials: _propTypes2.default.array,
	  fullImage: _propTypes2.default.string,
	  pricing: _propTypes2.default.shape({
	    heading: _propTypes2.default.string,
	    description: _propTypes2.default.string,
	    plans: _propTypes2.default.array
	  })
	};
	
	var ProductPage = function ProductPage(_ref2) {
	  var data = _ref2.data;
	  var frontmatter = data.markdownRemark.frontmatter;
	
	
	  return _react2.default.createElement(ProductPageTemplate, {
	    image: frontmatter.image,
	    title: frontmatter.title,
	    heading: frontmatter.heading,
	    description: frontmatter.description,
	    intro: frontmatter.intro,
	    main: frontmatter.main,
	    testimonials: frontmatter.testimonials,
	    fullImage: frontmatter.full_image,
	    pricing: frontmatter.pricing
	  });
	};
	
	ProductPage.propTypes = {
	  data: _propTypes2.default.shape({
	    markdownRemark: _propTypes2.default.shape({
	      frontmatter: _propTypes2.default.object
	    })
	  })
	};
	
	exports.default = ProductPage;
	var productPageQuery = exports.productPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-product-page-js-0864f66ca33bb53685d4.js